import { render, staticRenderFns } from "./PartnerDomain.vue?vue&type=template&id=8fe09ab6"
import script from "./PartnerDomain.vue?vue&type=script&lang=js"
export * from "./PartnerDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports